"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jflSmt = void 0;
exports.jflSmt = {
    groups: [
        {
            label: 'SMT Types and Locations',
            type: 'explicitMultipleOccurrence',
            layout: 'flex',
            options: {
                addButtonLabel: 'Add New Location',
                newOccurrenceLabel: 'New Location',
                editOccurrenceLabel: 'Edit Location',
                tableFields: ['SMT.Type', 'SMT.Location'],
                tableHeaders: true
            },
            fields: [
                { field: 'SMT.Type', size: '3' },
                { field: 'SMT.Location', size: '3' },
                { field: 'NCICDesignationCode', size: '3' }
            ]
        },
        {
            label: 'SMT Descriptors',
            type: 'explicitMultipleOccurrence',
            layout: 'flex',
            options: {
                addButtonLabel: 'Add New Descriptor',
                newOccurrenceLabel: 'New Descriptor',
                editOccurrenceLabel: 'Edit Descriptor',
                tableFields: [
                    'SMTDescriptors.SMTSource',
                    'SMTDescriptors.SMTClass',
                    'SMTDescriptors.SMTClassCode',
                    'SMTDescriptors.SMTLiteral'
                ],
                tableHeaders: true
            },
            fields: [
                { field: 'SMTDescriptors.SMTSource', size: '3' },
                { field: 'SMTDescriptors.SMTClass', size: '3' },
                { field: 'SMTDescriptors.SMTClassCode', size: '3' },
                { field: 'SMTDescriptors.SMTLiteral', size: '6' }
            ]
        }
    ]
};
//# sourceMappingURL=jfl-smt-type10.js.map